export var ProjectDataSet = [
	
	{
		'ProjectID': 'leadfinder',
		'DataType': 'project',
		'WebsiteData': {
			'link':'https://leadfinder.app/',
		},
		'Externals': {
			'View Live Application': 'https://leadfinder.app/'
		},
		'NavigationStyle': {
			'primaryColor': 'rgb(49,200,197, 0.7)',
			'secondaryColor': '#ffffff'
		}, 
		'ProjectItemData': {
			'title': 'LeadFinder',
			'snippet': 'Dynamic web scraping, serverless administrative dashboard, and an automated emailing service',
			'styles': {
				'hoverColor': 'rgba(255,255,255,0.9)',
				'headerColor': '#3F91A1',
				'snippetColor': '#3F91A1'
			},
			'backgroundImages': {
				'image1': '/media/parallax-hero/leadfinder/leadfinder-1.png',
				'image2': '/media/parallax-hero/leadfinder/leadfinder-2.png',
			}
		},
		'ContentPageData': {
			'background': {
				'imageURL': '/media/parallax-hero/leadfinder/leadfinder-1.png',
				'color': '#3E8E9D'
			},
			'board': {
				'title': 'LeadFinder.App',
				'position': 'Software Architect',
				'type': 'A dynamic web scraper feeding data into a beautiful React.JS dashboard',
				'brief': '',
				'story': `

				Finding reliable and consistent work is one of the most difficult and time intensive processes when working as a freelance developer . Web applications like AngelList, Indeed, and Craigslist have revolutionized the industry by providing easy to use platforms for connecting those in need of labor with the appropriately skilled workers. However, as the industry has grown over the years, the number of these platforms has also grown. It has become increasingly difficult for developers to manage multiple online profiles, sift through dozens of search platforms, and find related work. LeadFinder solves this issue. For a small monthly fee, users receive a batch of hand picked leads custom tailored to their industry in their inbox, everyday. I was contracted as the lead Project Manager and Architect for this project. From a technical perspective, there were three main objectives that needed to be completed. \n
				
				1) Implement Web-scraping system which aggregates 30-50 leads every day from a mixture of online sources. System needs to be easily maintainable for nontechnical users\n
				I published a web scraper utility powered by the Python Scrapy module which ran on an AWS EC2 instance using a CRON job. The scraper utilized a proxy in order to avoid being detected by larger sites like Craigslist which do a fantastic job of detecting web crawlers. Some sites change their HTML structure frequently, which meant I needed to design the system in a way that would ensure our selectors being used were up to date and matched the HTML structure of whatever site we were crawling. I designed unit tests that were executed automatically throughout the day that would notify system administrators of any issues with the system. I also created a simple JSON structure that allowed less technical developers to easily update a particular site’s selectors. \n
				
				2) Design administrative platform for employees to easily review aggregated leads each day and determine which leads are distributed to subscribed users\n
				I used ReactJS to implement rich functions in various pages: form validation, crud, grid list, search, sort, pagination, multi-selection, tags-input, advanced/custom directives, authentication, unit tests, etc. The resulting web application and administrative interface allowed internal support team to quickly approve and tag incoming data. Interface and process reduced daily workload by nearly 80%. I worked side-by-side with User Experience designers, leveraging multimedia content creation applications and digital media to continuously provide the best Customer Experience. \n
				
				3) Deploy landing page and automated emailing service\n
				For the emailing service, I configured automated emailing service using AWS Lambda’s, cron jobs, and Mailgun NPM module which launched approved data to subscribed customers.
				`,
				'deliverables': ['Javascript','Ant Design', 'HTML5','SCSS', 'React.js', 'Amazon Web Services','MailGun', 'Node.js', 'PHP', 'Xcode', 'Bash Command Scripting', 'Github', 'jQuery', 'Cross Company Communication & Team Management', 'Device Testing', 'Product Development'],
				'styles': {
					'buttonColor': '#3F91A1',
					'buttonArrowColor': 'rgb(255,255,255)',
					'headerColor': '#3F91A1',
					'backgroundColor': 'rgba(255,255,255,0.95)',
					'positionColor': '#3F91A1',
					'titleColor': '#3F91A1',
					'viewApplicationColor': '#3F91A1',
					'typeColor':  '#3F91A1',
					'briefColor': '#3F91A1',
					'storyColor': '#3F91A1',
					'skillColor': '#3F91A1',
					'externalsColor': '#3F91A1'
				}
				
			}
		}
	},
	
	{
		'ProjectID': 'clicktripz',
		'DataType': 'project',
		'WebsiteData': {
			'link':'https://www.clicktripz.com/',
		},
		'NavigationStyle': {
			'primaryColor': 'rgba(0,213,163,0.7)',
			'secondaryColor': 'white'
		}, 
		'ProjectItemData': {
			'title': 'ClickTripz',
			'snippet': 'A deep dive into the world of tool building and networks',
			'styles': {
				'hoverColor': 'rgba(0,197,204,0.85)',
				'headerColor': '#ffffff',
				'snippetColor': '#ffffff'
			},
			'backgroundImages': {
				'image1': '/media/parallax-hero/clicktripz/clicktripz-1-compressor.png',
				'image2': '/media/parallax-hero/clicktripz/clicktripz-2-compressor.png',
				'image3': '/media/parallax-hero/clicktripz/clicktripz-3-compressor.png',
			}
		},
		'ContentPageData': {
			'background': {
				'imageURL': '/media/parallax-hero/clicktripz/clicktripz-full.jpg',
				'color': 'rgba(6,156,167,0.7)'
			},
			'board': {
				'title': 'ClickTripz, LLC',
				'position': 'Senior Integration Engineer',
				'type': '1.5 Million Daily Users',
				'brief': 'Data-driven technology, empowering the travel industry. ClickTripz cloud-based solutions deliver proven results for travelers, advertisers, publishers & suppliers around the globe. Trusted by the top brands in travel such as TripAdvisor, Booking.com, HomeAway, Hilton, Spirit Airlines, Trivago, Kayak, Expedia, Hotels.com, Priceline, and many more.',
				'story': `At 20 years old, I was offered a remote integration engineering position with ClickTripz, LLC. I was employed as one of 8 original engineers on the company’s integration team. My job required a wide range of programming skills. I had to adapt on what felt like a daily basis due to the intense fluctuation and evolution of an early startup. I developed and deployed code that is currently being used by over 1.5 million users per day. My remote position showed me the intricacies of technical organization, self-awareness, team communication, and autonomous capabilities. I will go over a few of the areas I worked in but there was really so much involved in this company that its difficult to cover every aspect.   I built, modified, and maintained backend php firewalls for dozens of publishers which gave our front-end scripts responses on when to block users based on a number of factors such as location, IP, domain source, etc. I handled code migrations for publisher scripts from legacy code to an updated CTI framework. I implemented AdBlock hack functionality and First Party Content Shiled which allowed our script to run regardless of if the user had AdBlock turned on. I developed, refactored, and maintained numerous library plugins which our scripts relied on to efficiently handle incoming and outgoing data(validating airport codes, listening for DOM changes, recording data to AWS, tracking page views, placebo testing, etc). I tracked down countless bugs within the sdk, library files, plugins, and integration scripts using Logentries. I implemented placebo and lift testing which allowed the publishers to determine, among other things, whether our scripts were causing canalization to their site. I implemented gating mechanism to allow the publisher to test our products before they were pushed live. 
				
				I also handled a large number of business related tasks for the company as well. I worked with sales and  communicated directly with publisher representatives from large travel agencies to ensure products were specced and implemented correctly. I was tasked with training new integration members during their on-boarding period. I also trained and worked with QA engineers on how to properly debug scripts. `,
				'deliverables': ['Javascript', 'Amazon Web Services','Riot.js ', 'Node.js', 'PHP', 'Xcode', 'Bash Command Scripting', 'Github', 'jQuery', 'Google Chrome Extension Development', 'New Member On-boarding & Training', 'Cross Company Communication & Team Management', 'Networking', 'Firewall Infastructure', 'Device Testing', 'Product Development'],
				'styles': {
					'buttonColor': '#ffffff',
					'buttonArrowColor': 'rgb(24,205,208)',
					'headerColor': 'white',
					'backgroundColor': 'rgba(24,205,208,0.95)',
					'positionColor': 'white',
					'titleColor': 'white',
					'typeColor':  'white',
					'briefColor': 'white',
					'storyColor': 'white',
					'skillColor': 'white'
				}
				
			}
		}
	},
	{
		'ProjectID': 'sodacan-io',
		'DataType': 'project',
		'Externals': {
			'View Live Application': 'https://vigorous-lalande-12693f.netlify.com/',
			'View Behance': 'https://www.behance.net/gallery/67503929/SodaCanIO'
			// 'View Demo': 'https://www.youtube.com/watch?v=bNiRnUqeIJs',
		},
		'NavigationStyle': {
			'primaryColor': 'rgba(83,97,154,0.7)',
			'secondaryColor': 'white'
		}, 
		'ProjectItemData': {
			'title': 'SodaCan.IO',
			'snippet': 'Transforming the world of in-game advertising',
			'styles': {
				'hoverColor': 'rgba(83,97,154,0.85)',
				'headerColor': '#ffffff',
				'snippetColor': '#ffffff'
			},
			'backgroundImages': {
				'image1': '/media/parallax-hero/sodacan/sodacan-1.png',
				'image2': '/media/parallax-hero/sodacan/sodacan-2.png',
				'image3': '/media/parallax-hero/sodacan/sodacan-3.png',
			}
		},
		'ContentPageData': {
			'background': {
				'imageURL': '/media/parallax-hero/sodacan/sodacan-full.png',
				'color': '#5E7BB0'
			},
			'board': {
				'title': 'SodaCan.IO',
				'position': 'Lead Engineer',
				'type': 'Bridging the gap between developers and advertisers for in-game advertising',
				'brief': 'Visual tracking plugin for Unity connected to AWS services and paired with server-less React application ',
				'story': `Over the past 50 years, the computer game industry(sometimes referred to as the interactive entertainment industry) has risen at an exponential rate.
				In 2017, 2.2 billion gamers are expected to generate 108.9 billion in game revenue. An increase of 7.8% from the year before. 2018 is expected to generate $115.8 billion, 2019 $122.7 billion, and 2020 $128.5 billion. 
				Despite the industry’s explosive growth, advertisers have had a tough time in successfully exposing themselves inside these virtual environments. SodaCan.IO addresses the roadblocks that advertisers and developers have been confronted with in regards to in-game advertising. Here is a quick summary of how the SodaCan.IO product works and how it addresses the previous issues the industry has been met with. The SodaCan.IO web platform has 4 major parts and is designed to connect independent game developers to large brands. The platform houses an analytics dashboard, an app manager, a documentation page, and a support & feedback widget. Inside the app manager, the developer is provided with an api key and can create new “apps” which generate unique app IDs. The developer downloads our Unity plugin from the web platform and imports the plugin into their Unity project. Our plugin provides a custom navigation menu inside Unity which allows the developer to insert their api key and app ID which allows us to correctly identify the developer and application. The next step is for the developer to drag and drop a custom object from our plugin onto their game scene. During runtime, our plugin tracks a variety of visual metrics around that object and uploads those metrics to AWS. The metrics are used to display crucial information in the analytics dashboard and are also relayed to the related advertiser so that the developer can be compensated accordingly. One of the greatest features of our plugin is that we allow the developer to design the model how they see fit so that it is congruent with their artistic environment. The model goes through a streamlined approval process in which the brand/advertiser gets to approve the model dynamically within the webplatform(even during runtime). We use hashing to ensure that the model is not tampered with after the approval process. This was a great project for me as it exposed me to a variety of technical areas. I originally built the first visual tracking prototype. I then hired a seasoned Unity development team to push the system to the next level. I crafted project schedules which consistently produced the results we were reaching for. After handing off the Unity development, I handled the serverless react application and AWS architechture(lambdas, cognito, cloudfront, route 53, dynamodb, etc). I also worked wth various designers to develop an impactful user experience.`,
				'deliverables': ['Javascript', 'React-Serverless', 'Node.js', 'Unity', 'C++', 'AWS Lambda','AWS DynamoDB', 'AWS Cognito','AWS CloudFront', 'AWS S3', 'AWS Route 53','Ant Design','HTML5','CSS3','Team management', 'Product scheduling'],
				'styles': {
					'buttonColor': '#ffffff',
					'buttonArrowColor': 'rgb(83,97,154)',
					'headerColor': 'white',
					'backgroundColor': 'rgba(83,97,154,0.95)',
					'positionColor': 'white',
					'titleColor': 'white',
					'typeColor':  'white',
					'briefColor': 'white',
					'storyColor': 'white',
					'skillColor': 'white'
				}
				
			}
		}
	},
		
	{
		'ProjectID': 'greekleaf',
		'DataType': 'project',
		'WebsiteData': {
			// 'link':'https://itunes.apple.com/us/app/greekleaf/id1030946686?mt=8',
		},
		'Externals': {
			'View Behance': 'https://www.behance.net/gallery/67504183/GreekLeaf',
			// 'View On App Store': 'https://itunes.apple.com/us/app/greekleaf/id1030946686?mt=8'
		},
		'NavigationStyle': {
			'primaryColor': 'rgba(36,167,209,0.7)',
			'secondaryColor': 'white'
		}, 
		'ProjectDescription': `Example Description`,
		'ProjectItemData': {
			'title': 'GreekLeaf, LLC',
			'snippet': 'Everything your chapter needs... Now in one App...',
			'styles': {
				'hoverColor': 'rgba(69,207,173,0.85)',
				'headerColor': '#ffffff',
				'snippetColor': '#ffffff'
			},
			'backgroundImages': {
				'image1': '/media/parallax-hero/greekleaf/greekleaf-1-compressor.png',
				'image2': '/media/parallax-hero/greekleaf/greekleaf-2-compressor.png',
				'image3': '/media/parallax-hero/greekleaf/greekleaf-3-compressor.png'
			}
		},
		'ContentPageData': {
			'background': {
				'imageURL': '/media/parallax-hero/greekleaf/greekleaf-full.png',
				'color': '#ffffff'
			},
			'board': {
				'title': 'GreekLeaf, LLC',
				'position': 'Chief Executive Officer',
				'type': 'iOS & Web Application',
				'brief': 'GreekLeaf is an essential tool for any Greek Organization. Everything your chapter could need, tied into one fluid app. ',
				'story': `At 18 years old, during my freshman year of college, I left the traditional route of university education and became the founder and owner of GreekLeaf, LLC. I independently designed, developed, & deployed a native iOS application from scratch that enhanced and streamlined fraternity lifestyle by centralizing the functionality of multiple third party apps onto one platform. I implemented features such as login authentication, real-time messaging, geo-location tracking, push notifications, and Google API file sharing with Apple’s Swift language to create a seamless user experience. I created a parallel web application using Javascript, Node, and React to expand platform to a wider range of users. I led the initiative to present the app to investors, secure contract agreements, finalize third-party investments, and prepare the product for global distribution. I gathered extensive experience in the full cycle of software design process, including requirements, prototyping, design, interface implementation testing, and maintenance. `,
				'deliverables': ['iOS App Development', 'Web Development','Investment Presentations', 'Business Legitimization & Filing', 'Xcode', 'Swift','Parse Database', 'Objective-C', 'React.js ', 'Node.js ', 
				    'Javascript', 'Adobe Photoshop', 'Adobe Illustrator'],
				'styles': {
					'buttonColor': 'white',
					'buttonArrowColor': 'rgb(36,167,209)',
					'headerColor': 'white',
					'backgroundColor': 'rgba(36,167,209,0.7)',
					'positionColor': 'white',
					'titleColor': 'white',
					'typeColor': 'white',
					'briefColor': 'white',
					'storyColor': 'white',
					'skillColor': 'white'
				}
				
			}
		}
	},
	{
		'ProjectID': 'homium',
		'DataType': 'project',
		'WebsiteData': {},
		'Externals': {},
		'NavigationStyle': {
			'primaryColor': 'rgba(56,106,219,0.7)',                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
			'secondaryColor': '#ffffff'
		}, 
		'ProjectItemData': {
			'title': 'Homium                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    ',
			'snippet': 'CryptoCurrency & Home Loans',
			'styles': {
				'hoverColor': 'rgba(56,106,219,0.9)',
				'headerColor': '#ffffff',
				'snippetColor': '#ffffff'
			},
			'backgroundImages': {
				'image1': '/media/parallax-hero/homium/homium-1.png',
				'image2': '/media/parallax-hero/homium/homium-2.png',
				'image3': '/media/parallax-hero/homium/homium-3.png',
			}
		},
		'ContentPageData': {
			'background': {
				'imageURL': '/media/parallax-hero/homium/homium-full.png',
				'color': 'rgba(56,106,219)'
			},
			'board': {
				'title': 'Homium',
				'position': 'Front-end Lead',
				'type': 'CryptoCurrency & Home Loans',
				'brief': '',
				'story': `

					Apologies. No story here, only deliverables.

					• Handled development and maintenance of front-end SPA application by building administrative dashboard from scratch using React, Redux, and Ant Design \n
					• Configured a “Secure Component” React wrapper which combined with React Router for managing the custom display of various UI for a multi-type user authentication system without having to implement redundant routing and urls \n
					• Responsible for implementing Redux(actions & reducers) structure and Axios API calls to communicate with Ruby endpoints & AWS lambdas which transmitted responses to global Redux state \n
					• Designed custom configuration to allow for large-scale Ant-Design Form components which kept code abstracted and decluttered render() functions  \n
					• Simplified client Ethereum structure by abstracting Web3.js hooks to utility files which kept code clean and comprehensible \n
					• Coordinate with various project developers and teams(project funders, backend team) to ensure smooth development and achieve expected results within development time frame \n

				
				`,
				'deliverables': ['Javascript','Ant Design', 'HTML5','SCSS', 'React.js', 'Redux', 'Amazon Web Services', 'Github', 'jQuery', 'Cross Company Communication & Team Management', 'Device Testing', 'Product Development'],
				'styles': {
					'buttonColor': '#4482ff',
					'buttonArrowColor': 'rgb(255,255,255)',
					'headerColor': '#4482ff',
					'backgroundColor': 'rgba(255,255,255,0.95)',
					'positionColor': '#4482ff',
					'titleColor': '#4482ff',
					'viewApplicationColor': '#4482ff',
					'typeColor':  '#4482ff',
					'briefColor': '#4482ff',
					'storyColor': '#4482ff',
					'skillColor': '#4482ff',
					'externalsColor': '#4482ff'
				}
				
			}
		}
	},
	
	

	{
		'ProjectID': 'italeau',
		'DataType': 'project',
		'WebsiteData': {},
		'Externals': {},
		'NavigationStyle': {
			'primaryColor': 'rgb(0,0,0, 0.7)',                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
			'secondaryColor': '#ffffff'
		}, 
		'ProjectItemData': {
			'title': 'Italeau                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    ',
			'snippet': 'Shopify store for handcrafted italean wear',
			'styles': {
				'hoverColor': 'rgba(56,56,54,0.9)',
				'headerColor': '#ffffff',
				'snippetColor': '#ffffff'
			},
			'backgroundImages': {
				'image1': '/media/parallax-hero/italeau/italeau-1.png',
			}
		},
		'ContentPageData': {
			'background': {
				'imageURL': '/media/parallax-hero/italeau/italeau-1.png',
				'color': '#ffffff'
			},
			'board': {
				'title': 'Italeau',
				'position': 'Front-End Developer and UI Designer',
				'type': 'Shopify store for handcrafted italean wear',
				'brief': '',
				'story': `

				Apologies. No story here, only deliverables. Please return later :)

				• Collaborate with product team members to implement a wide range of functional features, UI designs, and custom javascript animations \n		
 				• Design custom administrative Shopify setup which allowed non technical company members to easily upload Instagram photos to UI grid using Instagram API \n	
				• Lead monitoring and reporting of website traffic and buyer performance by implementing Google Analytics across entire site and translating data to product teams \n

				`,
				'deliverables': ['Javascript','.Liquid', 'HTML5','CSS', 'jquery', 'Instagram API', 'UI Design'],
				'styles': {
					'buttonColor': '#000000',
					'buttonArrowColor': 'rgb(255,255,255)',
					'headerColor': '#000000',
					'backgroundColor': 'rgba(255,255,255,0.95)',
					'positionColor': '#000000',
					'titleColor': '#000000',
					'viewApplicationColor': '#000000',
					'typeColor':  '#000000',
					'briefColor': '#000000',
					'storyColor': '#000000',
					'skillColor': '#000000',
					'externalsColor': '#000000'
				}
				
			}
		}
	},
	{
		'ProjectID': 'elevate',
		'DataType': 'project',
		'WebsiteData': {
			// 'link':'http://ec2-52-55-8-92.compute-1.amazonaws.com/',
		},
		'ProjectDescription': `Example Description`,
		'ProjectItemData': {
			'title': 'Elevate Entertainment',
			'snippet': 'Social Media, Content Creation, and Business.',
			'styles': {
				'hoverColor': 'rgba(117,0,0,0.85)',
				'headerColor': '#ffffff',
				'snippetColor': '#ffffff'
			},
			'backgroundImages': {
				'image1': '/media/parallax-hero/elevate/elevate-1-compressor.png',
				'image2': '/media/parallax-hero/elevate/elevate-2-compressor.png',
				'image3': '/media/parallax-hero/elevate/elevate-3-compressor.png'
			}
		},
		'ContentPageData': {
			'background': {
				'imageURL': '/media/parallax-hero/elevate/elevate-full-compressor.jpg',
				'color': '#0F1003'
			},
			'board': {
				'title': 'Elevate Entertainment, LLC',
				'position': 'Chief Technical Officer',
				'type': 'Event Management',
				'brief': 'We’ve all been to the sticky walls, red cup on the floor, broken window kind of college party. Its great and all, but what if there was something better? Elevate Entertainment’s mission and goal is to redefine your experience. The team is built by enthusiastic and diverse individuals, dedicated to transforming the monotonous trend of celebrations.',
				'story': `After my big transition to Los Angeles, and stabilizing my financial stream through freelance contracting, I was offered a position to lead an exciting new startup in Gainesville, Florida. Soon after coming on board and structuring the technical platforms of the company, I was asked to become Elevate’s Chief Technical Officer. I accepted the position and became CTO and co-founder of one of the hottest event management companies at the largest university in the state of Florida. I worked remotely, transiting back from Oahu, Hawaii to Florida when the time called. I introduced a wide range of technical avenues to the company which allowed a fluid day to day workflow. Without these tools, no business could scale. Especially that of an event management company. I managed a wide range of processes. Web development, task platforms, Facebook & Instagram Advertising, SEO, Content Creation, Investments, customer support, database maintenance, online ticket sales, and so on. `,
				'deliverables': ['Social Media Management', 'Facebook & Instagram Advertising','Shopify Management & Development API', 'Social Media Management','Adobe Photoshop', 'Javascript', 'Amazon Web Services', 
				'React.js ', 'Node.js','jQuery', 'Bash Command Scripting ', 'CSS', 'HTML5'],
				'styles': {
					'buttonColor': '#ffffff',
					'buttonArrowColor': 'rgb(117,0,0)',
					'headerColor': 'white',
					'backgroundColor': 'rgba(117,0,0,0.7)',
					'positionColor': 'white',
					'titleColor': 'white',
					'typeColor': 'white',
					'briefColor': 'white',
					'storyColor': 'white',
					'skillColor': 'white'
				}
				
			}
		}
	},
	{
		'ProjectID': 'hulu',
		'DataType': 'project',
		'WebsiteData': {
			'link': ''
		},
		'NavigationStyle': {
			'primaryColor': 'rgba(61, 214, 125, 0.7)',
			'secondaryColor': 'white'
		}, 
		'ProjectDescription': `Example Description`,
		'ProjectItemData': {
			'title': 'Hulu',
			'snippet': 'Developing an internal platform for the Hulu Sales Team',
			'styles': {
				'hoverColor': 'rgba(61, 214, 125, 0.85)',
				'headerColor': '#ffffff',
				'snippetColor': '#ffffff'
			},
			'backgroundImages': {
				'image1': '/media/parallax-hero/hulu/hulu-1-min.jpg',
				'image2': '/media/parallax-hero/hulu/hulu-2-min.jpg',
			}
		},
		'ContentPageData': {
			'background': {
				'imageURL': '/media/parallax-hero/hulu/hulu-full-min.jpg',
				'color': '#ffffff'
			},
			'board': {
				'title': 'Hulu',
				'position': 'Contracted Developer',
				'type': 'Building an internal admin platform',
				'brief': '',
				'story': `I was hired by a creative agency in Venice Beach, CA to spearhead the development of a internal admin sales platform powered by React. Our goal was to deploy an Single Page Application for the Hulu Sales team before a quickly approaching deadline. The design and UX of the application was completed prior to my on boarding and thus I was focused solely on the inner functionality of the application. I implemented an organized and structured hierarchy for the application and it’s child components. The organized structure positively impacted the fluidity of user-interface transitions across the application. The application required implementation of numerous complex user-interface browser event options like drag and drop, right click menu, page animations, and many others. My position and objectives required the intuitive use and knowledge of many SPA and React fundamentals(React Router, React Transitions, Webpack, state managements, MVC structure, browser event driven applications).`,
				'deliverables': ['Javascript', 'Amazon Web Services', 
				'React.js ', 'Node.js','jQuery', 'Electron', 'CSS', 'HTML5'],
				'styles': {
					'buttonColor': '#ffffff',
					'buttonArrowColor': 'rgb(61, 214, 125)',
					'headerColor': 'white',
					'backgroundColor': 'rgba(58, 214, 120, 0.85)',
					'positionColor': 'white',
					'titleColor': 'white',
					'typeColor': 'white',
					'briefColor': 'white',
					'storyColor': 'white',
					'skillColor': 'white'
				}
				
			}
		}
	},
	// {
	// 	'ProjectID': 'thefartingdonald',
	// 	'DataType': 'project',
	// 	'WebsiteData': {
	// 		'link':'https://thefartingdonald.myshopify.com/',
	// 	},
	// 	'NavigationStyle': {
	// 		'primaryColor': 'rgba(253,133,148,0.7)',
	// 		'secondaryColor': 'white'
	// 	}, 
	// 	'ProjectDescription': `Example Description`,
	// 	'ProjectItemData': {
	// 		'title': 'The Farting Donald',
	// 		'snippet': 'Lets laugh about it!',
	// 		'styles': {
	// 			'hoverColor': 'rgba(253,133,148,0.85)',
	// 			'headerColor': '#ffffff',
	// 			'snippetColor': '#ffffff'
	// 		},
	// 		'backgroundImages': {
	// 			'image1': '/media/parallax-hero/fartingdonald/fartingdonald-1.png',
	// 			'image2': '/media/parallax-hero/fartingdonald/fartingdonald-2.png',
	// 			'image3': '/media/parallax-hero/fartingdonald/fartingdonald-3.png',
	// 		}
	// 	},
	// 	'ContentPageData': {
	// 		'background': {
	// 			'imageURL': '/media/parallax-hero/fartingdonald/fartingdonald-full.png',
	// 			'color': '#ffffff'
	// 		},
	// 		'board': {
	// 			'title': 'The Farting Donald',
	// 			'position': 'Lead Web Developer',
	// 			'type': 'eCommerce Store',
	// 			'brief': 'The Farting Donald is an online gag store that tries to provide a splash of humour in the serious arena of politics',
	// 			'story': `The client came to me with very little knowledge on web design, search engine optimization, and online marketing. I was given the position of lead web developer and began to make some immediate decisions that impacted the success of the company in a large way. We decided to use Shopify as our main web platform and also utilize separate services such as amazon, Facebook, and Instagram for outreach and brand awareness. Although Shopify is limiting in terms of design, the platform provides an incredible infrastructure and a wide range of tools that assist in creating an efficient online business. .liquid is also a very intuitive language and so it was easy for me to create the design and user experience that the client was looking for. `,
	// 			'deliverables': ['Javascript', 'Shopify','.liquid', 'HTML5', 'CSS3', 'Facebook & Instagram Marketing','Search Engine Optimization','Adobe Photoshop', 'Adobe Illustrator'],
	// 			'styles': {
	// 				'buttonColor': 'white',
	// 				'buttonArrowColor': 'rgb(244,88,106)',
	// 				'headerColor': 'white',
	// 				'backgroundColor': 'rgba(244,88,106,0.7)',
	// 				'positionColor': 'white',
	// 				'titleColor': 'white',
	// 				'typeColor': 'white',
	// 				'briefColor': 'white',
	// 				'storyColor': 'white',
	// 				'skillColor': 'white'
	// 			}
				
	// 		}
	// 	}
	// },
	{
		'ProjectID': 'pacifickonacoffee',
		'DataType': 'project',
		'WebsiteData': {
			// 'link':'https://pacifickonacoffee.com',
		},
		'NavigationStyle': {
			'primaryColor': 'rgba(88,72,119,0.7)',
			'secondaryColor': 'white'
		}, 
		'ProjectDescription': `Example Description`,
		'ProjectItemData': {
			'title': 'Pacific Kona Coffee',
			'snippet': '...I dont even drink coffee',
			'styles': {
				'hoverColor': 'rgba(88,72,119,0.85)', 
				'headerColor': '#ffffff',
				'snippetColor': '#ffffff'
			},
			'backgroundImages': {
				'image1': '/media/parallax-hero/pacifickonacoffee/pacifickonacoffee-1-compressor.png',
				'image2': '/media/parallax-hero/pacifickonacoffee/pacifickonacoffee-2-compressor.png',
				'image3': '/media/parallax-hero/pacifickonacoffee/pacifickonacoffee-3-compressor.png'
			}
		},
		'ContentPageData': {
			'background': {
				'imageURL': '/media/parallax-hero/pacifickonacoffee/pacifickonacoffee-full.png',
				'color': '#D3ACA0'
			},
			'board': {
				'title': 'Pacific Kona Coffee',
				'position': 'Chief Executive Officer',
				'type': 'Straight From The Islands, Right To Your Cup',
				'brief': 'Every bean hand-picked. Every blend hand-roasted. Ever package hand-painted. Pacific Kona Coffee is on a mission to change the luxury coffee industry. Feel the artistic energy and spirit of the native Hawaiian islands fill your kitchen and refine your morning experience. ',
				'story': `In 2017, I made a big transition and re-located to the North Shore of Oahu, Hawaii. Hawaii is very well known for their production of Kona Coffee. I recognized a lacking of technical procedures when comparing modern coffee companies to the Kona Coffee farming companies. The local farmer’s online presence and processes for automation were very much out of date. I embarked on an adventure and started a new project, Pacific Kona Coffee. Our team adopted the same structure as the coffee subscription companies which were doing incredibly well at the time. After speaking with the local farmers, we began to understand that although Kona Coffee is a wonderfully crafted beverage, the consumer’s of the product are more so attracted to the brand of Hawaii itself. Our team new we needed to embed the Hawaiian nature into our brand’s image. I hired an incredibly talented artist, Harrison Downs, to assist in building the brand. We travelled across the Hawaiian islands in order to find locations that matched the taste of the four Kona Coffee blends our company was offering to consumers. Harrison hand-painted each of the locations and they were used as the exterior bag design. The result was beautiful. Among other things, I hired my first employee, worked with foreign packaging companies, introduced automated packaging and shipping processes as well as an automated customer service system, handled Facebook Ad targeting, and customized the Shopify web design using the .liquid framework. `,
				'deliverables': [
					'Product Branding, Design, & Packaging', 
					'Logo Design',
					'Facebook & Instagram Advertising', 
					'Social Media Management', 
					'Adobe Products', 
					'.liquid',
					'Shopify', 
					'Search Engine Optimization', 
					'Javascript', 
					'HTML5', 
					'CSS3',
				],
				'styles': {
					'buttonColor': '#ffffff',
					'buttonArrowColor': 'rgb(88,72,119)',
					'headerColor': 'white',
					'backgroundColor': 'rgba(88,72,119,0.7)',
					'positionColor': 'white',
					'titleColor': 'white',
					'typeColor': 'white',
					'briefColor': 'white',
					'storyColor': 'white',
					'skillColor': 'white'
				}
				
			}
		}
	},
	{
		'ProjectID': 'adam',
		'DataType': 'project',
		'WebsiteData': {
			'link':'',
		},
		'NavigationStyle': {
			'primaryColor': 'rgba(23, 23, 23, 0.85)',
			'secondaryColor': 'white'
		}, 
		'ProjectDescription': `Example Description`,
		'ProjectItemData': {
			'title': 'Adam',
			'snippet': 'Who is this "Watson" you speak of?',
			'styles': {
				'hoverColor': 'rgba(23, 23, 23, 0.85)',
				'headerColor': 'rgb(117,217,159)',
				'snippetColor': 'rgb(117,217,159)'
			},
			'backgroundImages': {
				'image1': '/media/parallax-hero/adam/adam-1-compressor.png',
				'image2': '/media/parallax-hero/adam/adam-2-compressor.png',
				'image3': '/media/parallax-hero/adam/adam-3-compressor.png'
			}
		},
		'ContentPageData': {
			'background': {
				'imageURL': '/media/parallax-hero/adam/adam-full.png',
				'color': '#75D99F'
			},
			'board': {
				'title': 'Adam',

				'position': 'Independent Developer',
				'type': 'Artificial Intelligence + Stock Market + Daily News',
				'brief': 'A powerful use of IBM’s Artificial Intelligence API combined with a web scraper that tracks the latest news in the stock market. Built from the ground up, using scalable modules, Adam provides a new way to look at the day trading sector and relevant industry trends',
				'story': `After moving to Los Angeles, I was very interested in diving into the field of quantitative trading. I developed a ribbon-band trading algorithm using the MQL platform and C++ programming language. After completing the project, I moved in a new direction to launch a front-end platform. I built Adam, a Google Chrome Extension that gives users an accurately detailed sentiment analysis of a company and it's financial instrument. I created a custom web-scraper using Python and the ‘Beautiful Soup’ module. The scraper extracted text from the current day’s most popular headlines from top news publishers. The contents of the articles were digested by a sentiment analysis program(IBM’s Artificial Intelligence API, Watson). Watson returns a detailed analysis of the article’s “mood” and the results are displayed on the front-end to the user. This gives user’s a valuable asset when making an investment decision. I used Node.js & AJAX to execute Python scripts on the backend server, and then returned the results to the user on the front-end. I designed an intuitive user interface for data-visualization and deployed the front-end portion to the google chrome extension platform.`,
				'deliverables': [
					'Python', 
					'IBM Watson API',
					'Beautiful Soup Module ', 
					'Javascript', 
					'Node.js ', 
					'Ajax', 
					'React.js', 
					'jQuery', 
					'Google Chrome Extension Development', 
					'HTML5', 
					'CSS3', 
				],
				'styles': {
					'buttonColor': 'rgb(117,217,159)',
					'buttonArrowColor': 'white',
					'headerColor': 'rgb(117,217,159)',
					'backgroundColor': 'rgba(23, 23, 23, 0.9)',
					'positionColor': 'rgb(117,217,159)',
					'titleColor': 'rgb(117,217,159)',
					'typeColor': 'rgb(117,217,159)',
					'briefColor': 'rgb(117,217,159)',
					'storyColor': 'rgb(117,217,159)',
					'skillColor': 'rgb(117,217,159)'
				}
				
			}
		}
	},
	{
		'ProjectID': 'hitmusicgroup',
		'DataType': 'project',
		'ProjectTimeline':'2015',
		'ProjectLogo': 'media/logos/ClickTripz.png',
		'SkillSet': {
			'swift':'media/skillsets/Swift.png',
			'xcode':'media/skillsets/xcode.png',
			'node':'media/skillsets/nodejs.png',
			'css':'media/skillsets/css3.png',
			'html5':'media/skillsets/HTML5.png',
			'javascript':'media/skillsets/Javascript.png',
			'react':'media/skillsets/react.png',
		},
		'WebsiteData': {
			'link':'',
		},
		'ProjectDescription': `Example Description`,
		'ProjectItemData': {
			'title': 'Hit Music Group',
			'snippet': 'Supercharged Workflow',
			'styles': {
				'hoverColor': 'rgba(0, 47, 53, 0.85)',
				'headerColor': '#ffffff',
				'snippetColor': '#ffffff'
			},
			'backgroundImages': {
				'image1': '/media/parallax-hero/hitmusicgroup/hitmusicgroup-1-compressor.png',
				'image2': '/media/parallax-hero/hitmusicgroup/hitmusicgroup-2-compressor.png'
			}
		},
		'ContentPageData': {
			'background': {
				'imageURL': '/media/parallax-hero/hitmusicgroup/hitmusicgroup-full-compressor.jpeg',
				'color': 'rgb(0, 47, 53)'
			},
			'board': {
				'title': 'Hit Music Group',
				'position': 'Freelance web developer',
				'type': 'React Web Application',
				'brief': 'The art of product scheduling, team management, and working with high value clients',
				'story': `Hit Music Group is a collective group of hip-hop and rap artists. Some of the artists include Sean Kingston, Lil Yachty, and Famous Dex. Hit Music Group hired me to create a digital platform that increased the online presence of their group. I leveraged responsive web-frameworks to consistently complete product deliverables ahead of schedule. I utilized Node.js, React, jQuery, & Parallax.js to create a full stack application that met client’s design specifications. I translated technical aspects of product management cycle in order to gather requirements, create efficient product schedule, give crucial project updates to client, and successfully deploy the product by a set deadline`,
				'deliverables': [
					'Javascript', 
					'Node.js',
					'React.js', 
					'HTML5', 
					'CSS'
				],
				'styles': {
					'buttonColor': 'white',
					'buttonArrowColor': 'rgba(0, 47, 53, 0.8)',
					'headerColor': 'white',
					'backgroundColor': 'rgba(0, 47, 53, 0.8)',
					'positionColor': 'white',
					'titleColor': 'white',
					'typeColor': 'white',
					'briefColor': 'white',
					'storyColor': 'white',
					'skillColor': 'white'
				}
				
			}
		}
	},
	{
		'ProjectID': 'injectjs',
		'DataType': 'project',
		'ProjectTimeline':'2015',
		'ProjectLogo': 'media/logos/ClickTripz.png',
		'SkillSet': {
			'swift':'media/skillsets/Swift.png',
			'xcode':'media/skillsets/xcode.png',
			'node':'media/skillsets/nodejs.png',
			'css':'media/skillsets/css3.png',
			'html5':'media/skillsets/HTML5.png',
			'javascript':'media/skillsets/Javascript.png',
			'react':'media/skillsets/react.png',
		},
		'WebsiteData': {
			'link':'',
		},
		'ProjectDescription': `Example Description`,
		'ProjectItemData': {
			'title': 'Inject JS',
			'snippet': 'Supercharged Workflow',
			'styles': {
				'hoverColor': 'rgba(102, 82, 178, 0.85)',
				'headerColor': '#ffffff',
				'snippetColor': '#ffffff'
			},
			'backgroundImages': {
				'image1': '/media/parallax-hero/injectjs/injectjs-1-compressor.png',
				'image2': '/media/parallax-hero/injectjs/injectjs-2-compressor.png',
				'image3': '/media/parallax-hero/injectjs/injectjs-3-compressor.png'
			}
		},
		'ContentPageData': {
			'background': {
				'imageURL': '/media/parallax-hero/injectjs/injectjs-full-min.jpg',
				'color': '#3D5297'
			},
			'board': {
				'title': 'Inject JS',

				'position': 'Company Tooling',
				'type': 'An introductory to the World of Tool Building',
				'brief': 'Inject JS is a simple and elegant way to simulate development environments across the web. It takes advantage of the fluid Google Chrome Platform and injects script onto a particular web page. This allows a developer to quickly inject a development script onto a live web page.',
				'story': `After being brought onto the integration’s live team at ClickTripz, I was excited to contribute my skills to the team. The ClickTripz integration’s development workflow depended on our engineers simulating a development environment on a publisher’s web page. This gives our developers and quality assurance team the ability to test script modifications before launching changes live to millions of users. InjectJS offered a fast and easy way to simulate the development environment. Instead of the engineer copying and pasting numerous code lines to the browser console, they would instead paste the source link of their script into the InjectJS google chrome extension. The extension handled all the heavy lifting for injecting the script onto the page which eliminated unnecessary development time.`,
				'deliverables': [
					'Javascript', 
					'Node.js',
					'React.js', 
					'HTML5', 
					'CSS'
				],
				'styles': {
					'buttonColor': 'white',
					'buttonArrowColor': 'rgba(0, 47, 53, 0.8)',
					'headerColor': 'white',
					'backgroundColor': 'rgba(0, 47, 53, 0.8)',
					'positionColor': 'white',
					'titleColor': 'white',
					'typeColor': 'white',
					'briefColor': 'white',
					'storyColor': 'white',
					'skillColor': 'white'
				}
				
			}
		}
	},
	{
		'ProjectID': 'neuehouse',
		'DataType': 'project',
		'WebsiteData': {
			'link':'https://www.neuehouse.com/',
		},
		'NavigationStyle': {
			'primaryColor': 'rgba(33,30,31,0.7)',
			'secondaryColor': '#ffffff'
		}, 
		'ProjectItemData': {
			'title': 'Neue House',
			'snippet': 'Inspired to work, created to inspire',
			'styles': {
				'hoverColor': 'rgba(33,30,31,0.9)',
				'headerColor': '#ffffff',
				'snippetColor': '#ffffff'
			},
			'backgroundImages': {
				'image1': '/media/parallax-hero/hulu/hulu-1-min.jpg',
				'image2': '/media/parallax-hero/neuehouse/neuehouse-2.png',
			}
		},
		'ContentPageData': {
			'background': {
				'imageURL': '/media/parallax-hero/neuehouse/NeueHouse-Logo.png',
				'color': '#ffffff'
			},
			'board': {
				'title': 'NeueHouse',
				'position': 'Software Engineer',
				'type': 'iOS and Android Application',
				'brief': '',
				'story': `

				
				`,
				'deliverables': ['Javascript', 'React', 'React Native', 'HTML', 'CSS'],
				'styles': {
					'buttonColor': '#ffffff',
					'buttonArrowColor': 'rgb(33,33,33)',
					'headerColor': '#ffffff',
					'backgroundColor': 'rgba(33,30,31,0.95)',
					'positionColor': '#ffffff',
					'titleColor': '#ffffff',
					'viewApplicationColor': '#ffffff',
					'typeColor':  '#ffffff',
					'briefColor': '#ffffff',
					'storyColor': '#ffffff',
					'skillColor': '#ffffff',
					'externalsColor': '#ffffff'
				}
				
			}
		}
	},
]


